{
  "modal": {
    "close": "Close"
  },
  "upload": {
    "title": "Uploads",
    "doneCount": "{done}/{total} done",
    "inProgress": "{active} in progress",
    "clearFinished": "Clear finished",
    "cancel": "Cancel",
    "retry": "Retry",
    "status": {
      "queued": "Queued",
      "preparing": "Reading…",
      "done": "Done",
      "cancelled": "Cancelled",
      "failed": "Failed"
    }
  },
  "tagPicker": {
    "addTag": "Add tag…",
    "create": "Create",
    "noMatches": "No matching tags",
    "remove": "Remove"
  },
  "currency": {
    "label": "Currency",
    "add": "Add a currency",
    "addSave": "Add",
    "code": "Code",
    "name": "Name",
    "namePlaceholder": "e.g. Euro",
    "invalid": "Enter a 3-letter currency code (e.g. EUR)."
  },
  "photoUpload": {
    "uploading": "Uploading…",
    "change": "Change photo",
    "upload": "Upload photo",
    "hint": "JPEG, PNG, WebP or GIF · up to 5 MB",
    "badType": "Use a JPEG, PNG, WebP, or GIF image",
    "tooLarge": "Image too large (max 5 MB)",
    "failed": "Upload failed"
  },
  "editor": {
    "textStyle": "Text style",
    "bold": "Bold",
    "italic": "Italic",
    "bulletList": "Bullet list",
    "link": "Link",
    "inlineCode": "Inline code",
    "linkPrompt": "Link URL",
    "normalText": "Normal text",
    "heading1": "Heading 1",
    "heading2": "Heading 2",
    "heading3": "Heading 3"
  },
  "album": {
    "allAlbums": "All albums",
    "edit": "Edit",
    "delete": "Delete",
    "deleteAlbum": "Delete album",
    "setAsCover": "Set as cover",
    "download": "Download",
    "remove": "Remove",
    "openFull": "Open full",
    "close": "Close",
    "approve": "Approve",
    "reject": "Reject",
    "confirm": "Confirm",
    "select": "Select",
    "clearSelection": "Clear selection",
    "selected": "{count} selected",
    "selectAll": "Select all ({count})",
    "pending": "Pending",
    "cover": "Cover",
    "tags": "Tags",
    "tagPlaceholder": "Search or create a tag…",
    "itemOne": "item",
    "itemOther": "items",
    "coverUpdated": "Album cover updated",
    "approved": "Approved",
    "fetchFailed": "Couldn't fetch {name}",
    "downloaded": "Downloaded {count} {items} as {name}",
    "downloadFailed": "Download failed: {message}",
    "uploaded": "{count} {items} uploaded{failed}",
    "submitted": "{count} {items} submitted for approval{failed}",
    "failedSuffix": ", {count} failed",
    "skippedUnsupported": "Skipped \"{name}\" — unsupported type",
    "deleteItemsHeading": "Delete items",
    "deleteItemsMessage": "Permanently delete {count} {items}? This can't be undone.",
    "deleteItemHeading": "Delete item",
    "deleteItemMessage": "Delete \"{name}\"? This can't be undone.",
    "rejectHeading": "Reject submission",
    "rejectMessage": "Reject \"{name}\"? It will be deleted and the student notified. You can add a reason below.",
    "deleteAlbumHeading": "Delete album",
    "deleteAlbumMessage": "Delete album \"{name}\" and all its media? This can't be undone.",
    "uploadSubmit": "Drop photos or videos to submit for approval",
    "uploadDrop": "Drop photos or videos here, or click to upload",
    "preparingZip": "Preparing ZIP — {done}/{total}",
    "emptyHeading": "Empty album",
    "emptySubmit": "Submit the first photos or videos.",
    "emptyUpload": "Upload the first photos or videos.",
    "emptyNothing": "Nothing here yet.",
    "awaitingApproval": "awaiting approval",
    "taken": "Taken {date}",
    "reasonPlaceholder": "Reason (optional, shared with the student)"
  }
}
